import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersRegistrationRoutingModule } from './users-registration-routing.module';
import { UsersRegistrationComponent } from './users-registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TabsModule } from 'ngx-tabset';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { UsersComponent } from './users-component';
import { ConfirmationService } from 'primeng/api';

import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    UsersRegistrationComponent,
    UsersComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TabsModule,
    NgxPaginationModule,
    // ConfirmPopupModule,
    ReactiveFormsModule,
    NgxScrollTopModule,
    UsersRegistrationRoutingModule
  ],
   providers: [ConfirmationService ],
})
export class UsersRegistrationModule { }
